import { Component } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { FormComponentLookup } from '@ptl/forms';
import { CommonFormMemberLookupComponent } from '../common-form-member-lookup/common-form-member-lookup.component';
import { WhbCrosswalk } from '../../../shared/components/interfaces/member-lookup.interface';
import { ReducerUtilityService } from 'src/app/shared/utility-services/reducer-utility.service';
import { WholeHealthBalanceCrosswalk } from '../../../shared/components/configs/interfaces/whole-health-balance-and-agent-cube-state-structure.interface';

@FormComponentLookup('whb-member-lookup')
@Component({
    selector: 'app-whb-member-lookup',
    templateUrl: './whb-member-lookup.component.html',
    styleUrls: ['./whb-member-lookup.component.scss'],
    standalone: false
})
export class WholeHealthBalanceMemberLookupComponent extends CommonFormMemberLookupComponent {

  isCrosswalkValid: boolean = false;

  constructor() {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();

    const reducerUtilityService = this.injector.get(ReducerUtilityService);
    const crosswalkState: WholeHealthBalanceCrosswalk = reducerUtilityService.getState('WholeHealthBalanceCrosswalk');
    this.isCrosswalkValid = !!(crosswalkState?.whbcrosswalk?.whbcrosswalk && crosswalkState.whbcrosswalk.oldGroup && crosswalkState.whbcrosswalk.newGroup);
  }

  ngAfterViewInit(): void {
    super.ngAfterViewInit();

    const formControl: AbstractControl = this.formControls[this.entry.formControlAttributes.formControlName];

    formControl.addValidators((control: AbstractControl) => {
      return this.isCrosswalkValid ? null : { 'invalidCrosswalkInfo': true };
    });

    formControl.updateValueAndValidity();
  }

  override onCrosswalkResponse(crosswalk: WhbCrosswalk): void {
    this.isCrosswalkValid = !!(crosswalk?.whbcrosswalk && crosswalk?.oldGroup && crosswalk?.newGroup);

    const formControl: AbstractControl = this.formControls[this.entry.formControlAttributes.formControlName];
    formControl.updateValueAndValidity();
  }
}
